module.exports = __webpack_public_path__ + "img/delivery-empty@2x.ef2f0528.png";